export default __webpack_public_path__ + "static/media/a018-9.55ba292a.svg";